/** Keep short Russian prepositions with the next word, without long unbreakable runs. */
export function headingText(text: string): string {
  return text.replace(/(^|\s)(в|во|на|с|со|к|ко|у|о|об|от|до|из|за|по|и|а|но|не|для|без) +([^\s]+)/giu,
    (match, before: string, word: string, next: string) => word.length + next.length <= 22 ? `${before}${word}\u00a0${next}` : match);
}
